import { node, icon as iconFce } from "~/util/dom";
import createSDSIcon from "./icon";
import { ISDSIcon } from "@sznds/icons";
import { ISDSIconMulti } from "~/interfaces";

interface IHeaderButton extends HTMLButtonElement {
	icon: ISDSIcon | ISDSIconMulti | string;
}

export default function createHeaderButton({
	className = "",
	icon,
	innerHTML = "",
	...rest
}: Partial<IHeaderButton>): HTMLButtonElement {
	const button = node("button", {
		className: `ui-header-button ${className}`,
		...rest,
	});

	if (!innerHTML) {
		button.classList.add("icon-only");
	}

	if (typeof icon === "string") {
		const sdsSpan = node("span", { className: "header-icon" });

		sdsSpan.appendChild(iconFce(icon));
		button.appendChild(sdsSpan);
	} else {
		button.appendChild(createSDSIcon({
			symbol: icon,
		}));
	}

	if (innerHTML) {
		const text = node("span", { className: "ui-header-button__text", innerHTML });

		button.appendChild(text);
	}

	return button;
}
